import React, { useState } from "react";
import Sidebar from "../Components/Sidebar/Sidebar";
import "./Dashboard.css";
import "./Shimmer.css";
import Navbar from "../Components/Navbar/Navbar";

const Dashboard = () => {
  const [wealthActive, setWealthActive] = useState(false);
  const [walletActive, setWalletActive] = useState(false);

  const wealthActiveFun = () => {
    setWealthActive(false);
    setWalletActive(true);
  };

  const wallethActiveFun = () => {
    setWalletActive(false);
    setWealthActive(true);
  };
  return (
    <>
      <Navbar />
      <div className="dashboard-main-wrapper">
        <Sidebar />

        <div className="dashboard-main-wrap">
          <div className="dashboard-card-wrap">
            <div className="dashboard-card" onClick={wealthActiveFun}>
              <div className="nact-card-logo-wrap">
                <img src="./images/icons/nact-card-logo.png" alt="icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
